import React, { useContext, useEffect } from 'react';
import styles from './CustomSettings.module.scss';
import { withRouter } from 'react-router-dom';
import {
	Header,
	Sidebar,
	SideMenu,
	PageContainer,
	Page,
	PageAuth,
	LastActivity,
	PageHeader,
	AccountActions,
	PERMISSIONS,
} from '../..';
import { CustomSettingsForm } from './components';
import { profilePages, profileRestricted, useStore, PropertyType } from '../../../common';
import { AuthContext } from '../../../logic';

export const CustomSettingsComponent = (props: PropertyType): JSX.Element => {
	const [, dispatch] = useStore(false);
	const { user, token } = useContext(AuthContext);
	const { id } = props.match.params;
	const isCurrentUser = user?.id === +id;

	useEffect(() => {
		dispatch('USER_INIT', { token, id });
	}, [user, id]);

	const onSettingsSubmit = () => {
		dispatch('SETTINGS_SUBMIT', token);
	};

	// const onResetToDefaultSubmit = () => {
	// 	dispatch('RESET_TO_DEFAULT_SUBMIT', token);
	// };

	return (
		<>
			<Header dataId='header' />
			<PageAuth permission={PERMISSIONS.canViewUser}>
				<PageContainer>
					<Sidebar dataId='account-sidebar' opened>
						<SideMenu
							options={
								user?.permissions?.isSuperAdmin || user?.permissions?.canViewUserDetails
									? profilePages
									: profileRestricted
							}
						/>
					</Sidebar>
					<Page>
						<PageHeader title='Custom Settings'>{!isCurrentUser ? <AccountActions /> : null}</PageHeader>
						<section className={styles.PageContent}>
							<LastActivity />
							<CustomSettingsForm onSubmit={onSettingsSubmit} />
							{/*{(user?.permissions?.isSuperAdmin || canChangeUserDetails) && (*/}
							{/*	<ActionContainer>*/}
							{/*		<h5>Reset values to default</h5>*/}
							{/*		<p>{RESET_TO_DEFAULT_MESSAGE}</p>*/}
							{/*		<Button*/}
							{/*			title='Reset values'*/}
							{/*			small*/}
							{/*			onClick={onResetToDefaultSubmit}*/}
							{/*			dataId='reset-to-default-button'*/}
							{/*		/>*/}
							{/*	</ActionContainer>*/}
							{/*)}*/}
						</section>
					</Page>
				</PageContainer>
			</PageAuth>
		</>
	);
};

const CustomSettings = withRouter(CustomSettingsComponent);

export { CustomSettings };
